import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { skipTenantInterceptor } from '@asamco/utils';
import { Observable } from 'rxjs';
import { SignInCurrentUserResponse } from './sign-in-current-user-response.interface';

@Injectable({
	providedIn: 'root',
})
export class RemoteAppService {
	private readonly controllerName = 'RemoteApp';

	constructor(private http: HttpClient) {}

	public signInCurrentUser(appOid: string): Observable<SignInCurrentUserResponse> {
		return this.http.post<SignInCurrentUserResponse>(`${this.controllerName}/SignInCurrentUser/${appOid}`, undefined, {
			headers: skipTenantInterceptor(),
		});
	}
}
